module.exports = __webpack_public_path__ + "static/media/country_vn.da889cb7.webp";